import axios from "axios";

export const state = {
    reportproductsprofits: [],
};

export const getters = {
    reportproductsprofits: state => state.reportproductsprofits,
};

export const mutations = {
    setReportProductsProfit(reportproductsprofits, newValue) { state.reportproductsprofits = newValue},
};

export const actions = {
    fetchReportProductsProfit({ commit }) {
        axios.get('/reportproductsprofits').then(res => {
            commit('setReportProductsProfit', res.data.profits)
        })
    },
    filterReportProductsProfit({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportproductsprofits";
        axios.post(url, formData).then((response) => {
            commit('setReportProductsProfit', response.data.profits)
        })
    },
};
